module.exports = __webpack_public_path__ + "static/money-1200-600-29ce3087cc71cecbcbaa99473a876922.png";